import React from 'react';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '@modules/portableTextBlock';

const EventCards = ({ leftCard, rightCard, smallText, blockConfig }) => {
  return (
    <BlockWrapper
      {...blockConfig}
      className='grid grid-cols-14 text-center card-slider'>
      <div className='col-start-2 col-end-14 flex flex-col lg:flex-row gap-y-8 lg:gap-x-20 text-white prose md:prose-lg event-cards'>
        <div className='w-full bg-black pt-8 pb-12 lg:py-16 px-8'>
          <PortableTextBlock text={leftCard} />
        </div>

        <div className='w-full bg-black pt-8 pb-12 lg:py-16 px-8'>
          <PortableTextBlock text={rightCard} />
        </div>
      </div>

      <div className='col-start-3 col-end-13 text-black mt-10 lg:mt-20'>
        {smallText.map((line, i) => {
          return (
            <p
              key={i}
              className={`text-xs leading-xs md:text-sm md:leading-sm ${
                i !== 0 && 'mt-4'
              }`}>
              {line}
            </p>
          );
        })}
      </div>
    </BlockWrapper>
  );
};

export default EventCards;
